import { FC } from "react";
import { LegacyDesktopFooter } from "../../widgets/footer";
import { LegacyDesktopHeader } from "../../widgets/header";
import { useLocation, Location } from "react-router";

const isFullSize = (location: Location<any>) => {
    const path = location.pathname;
    return (
        path.includes('/fan-app')
        || path.includes('/fan-mvp')
        || path.includes('/club-100')
        || path.includes('/news')
        || path.includes('/matchcenter')
        || path.includes('/stadium')
        || path.includes('/team')
        || path.includes('/games')
        || path.includes('/tables')
        || path.includes('/goroda')
        || path.includes('/academy')
        || path.includes('/club')
        || path.includes('/timeline')
        || path.includes('/partners')
        || path.includes('/jobs')
    )
}

interface LegacyDesktopLayoutProps {
    children?: React.ReactNode;
}

export const LegacyDesktopLayout: FC<LegacyDesktopLayoutProps> = ({
    children,
}) => {
    const location = useLocation();
    const bgUrl = ` bg-[url(https://fcrodina.com/static/images/bg/rodina.jpg)]`;
    const bgClass = "bg-fixed" + bgUrl;
    let contentClass = "w-full bg-white/95";
    if (!isFullSize(location)) {
        contentClass += " mx-auto";
    }
    return (
        <div className={bgClass}>
            <LegacyDesktopHeader />
            <div className={contentClass} style={{ fontFamily: 'Futura, sans-serif' }}>
                {children}
            </div>
            <LegacyDesktopFooter />
        </div>
    );
}
